/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import toast from '@/services/toast';
import countries from '@/services/country.json'
export default {
  name: 'lbil-users-list',
  components: {},
  props: [],
  data () {
    return {
      getLbilUsersListData:null,
      getLbilUsersListDataResults:[],
      countryList:[],
      consultDoctorInfoPopupState:false
    }
  },
  computed: {
  ...mapGetters([
    'getLbilUsersListGetters'
  ]),
  getDoctorConsultRequestDataFun(){
   this.getLbilUsersListData = this.$store.getters.getLbilUsersListGetters.data
   return 
  },
  SetIntialStatus() {
    if(this.getLbilUsersListData){
      this.getLbilUsersListDataResults = this.getLbilUsersListData.data
    }
    return;
  },
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getDoctorConsultRequestDataFun
    this.SetIntialStatus 
  },
  methods: {
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    getDoctorConsultRequestDataFun(){
      return this.$store.getters.getLbilUsersListGetters;
    },
    SetIntialStatus() {
      if(this.getLbilUsersListData){
        this.getLbilUsersListDataResults = this.getLbilUsersListData.data
      }
      return;
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}